import { Component, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'
import { createQuiteProjectOrder, getWorkOrderSign, queryRefundOrder, editSubmitterRefundOrder, editChangeTeacher, editChangeCourse, queryCourse, getChangeCourseOrder, getChangeTeacherOrder, queryAllMainTeacher } from '@/api'

@Component({ name: 'create-order-page' })
export default class CreateOrderPage extends Vue {
  private orderId: any = null
  private orderType: any = null // 3-更换项目 4-更换老师 7-退项目
  private sData: any = {}
  private action: any = null // create-创建 edit-编辑
  private quitProjectReason = '' // 退项目的原因
  private courseList: any = [] // 项目列表
  private replaceProject: any = null // 替换的项目
  private remark: any = '' // 备注
  private pageType: any = null
  private teacherList: any = [] // 导师列表
  private replaceTeacher: any = null // 选择要换的导师
  created () {
    this.orderId = this.$route.query.id
    // this.orderType = Number(this.$route.query.dataType)
    // this.pageType = Number(this.$route.query.type)
    this.orderType = Number(this.$route.query.type)
    this.action = this.$route.query.action || 'create'
    this.initPageData()
  }

  private async initPageData () {
    let result: any = null
    if (this.action === 'quit' && (this.orderType === 1 || this.orderType === 2 || this.orderType === 0)) {
      result = await getWorkOrderSign({ id: this.orderId })
    } else {
      if (this.orderType === 3) { // 3 换项目
        const data: any = await getChangeCourseOrder({ id: this.orderId })
        this.courseList = await queryCourse({ courseType: data.student.courseTypeId })
        result = data.student
      } else if (this.orderType === 4) { // 4 换老师
        const data: any = await getChangeTeacherOrder({ id: this.orderId })
        this.teacherList = await queryAllMainTeacher({})
        result = data.student
      } else if (this.orderType === 7) { // 退项目重新编辑接口
        result = await queryRefundOrder({ id: this.orderId })
      }
    }
    this.sData = result
  }

  private async onSubmitClick () {
    if (this.orderType === 7 || this.action === 'quit') { // 退项目
      if (this.action === 'edit') { // 重新编辑退项目
        const { error }: any = await editSubmitterRefundOrder({ workOrderId: this.orderId, cause: this.quitProjectReason })
        if (!error) {
          TagsViewModule.delView(this.$route)
          this.$router.go(-1)
        }
      }
      if (this.action === 'quit') { // 退项目操作。
        const { error }: any = await createQuiteProjectOrder({ courseId: this.sData.courseId, courseType: this.sData.courseTypeId, workOrderId: this.orderId, cause: this.quitProjectReason, sellOrderId: this.sData.sellOrderId, studentId: this.sData.studentId })
        if (!error) {
          TagsViewModule.delView(this.$route)
          this.$router.go(-1)
        }
      }
    } else if (this.orderType === 3 && this.action !== 'quit') { // 换项目
      const { error }: any = await editChangeCourse({ workOrderId: this.orderId, newCourseId: this.replaceProject, remark: this.remark, sellOrderId: this.sData.sellOrderId })
      if (!error) {
        TagsViewModule.delView(this.$route)
        this.$router.go(-1)
      }
    } else if (this.orderType === 4 && this.action !== 'quit') { // 换老师
      const { error }: any = await editChangeTeacher({ workOrderId: this.orderId, newTeacherId: String(this.replaceTeacher), remark: this.remark, sellOrderId: this.sData.sellOrderId })
      if (!error) {
        TagsViewModule.delView(this.$route)
        this.$router.go(-1)
      }
    }
  }
}
